import React, { useContext } from "react";
import { QuestionContext } from "../../context";
import { RichText } from "../RichText";
import classNames from "classnames";

interface AnswerProps extends RenderComponent {
    answer?: any;
}

export function Answer({ answer, className, style }: AnswerProps) {
    const ctx = useContext(QuestionContext);

    if (ctx.type === "SingleChoice") {
        return (
            <RichText
                className={classNames("QuestionAnswer", className)}
                style={style}>
                {ctx.data.options
                    .map((data, index) => ({
                        index: String.fromCharCode(65 + index),
                        data
                    }))
                    .find(option => answer === option.data.id)?.index ||
                    "未作答"}
            </RichText>
        );
    }

    if (ctx.type === "MultiChoice") {
        return (
            <RichText
                className={classNames("QuestionAnswer", className)}
                style={style}>
                {ctx.data.options
                    .map((data, index) => ({
                        index: String.fromCharCode(65 + index),
                        data
                    }))
                    .filter(option => answer?.includes(option.data.id))
                    ?.map(item => item.index)
                    .join("") || "未作答"}
            </RichText>
        );
    }

    if (ctx.type === "Judge") {
        return (
            <RichText
                className={classNames("QuestionAnswer", className)}
                style={style}>
                {answer ? "正确" : "错误"}
            </RichText>
        );
    }

    if (ctx.type === "Fill") {
        return (
            <div
                className={classNames("QuestionAnswer", className)}
                style={style}>
                {answer?.map((item: string, index: number) => (
                    <div key={index}>
                        ({index + 1}) {item || "未作答"}
                    </div>
                ))}
            </div>
        );
    }

    if (ctx.type === "Subjective") {
        return (
            <RichText
                className={classNames("QuestionAnswer", className)}
                style={style}>
                {answer || "未作答"}
            </RichText>
        );
    }

    return null;
}
